import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IComponentController } from 'angular';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';

interface IPageGs0054 extends IComponentController {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}
/* @ngInject */
export default function Gs0054Controller(Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass) {
    const vm: IPageGs0054 = this;

    vm.multiOccurrenceOptions = {
        colonnesFixesGauche: [
            { nom: 'usqseqaff', largeur: 110 }
        ],
        colonnesVisibles: [
            { nom: 'usqquestion_t', largeur: 400 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('usqseqaff', { required: true }),
            new FormulaireItem('usqquestion_t', { required: true })
        ]),
        fonctions: {
            edition: true,
            nouveau: true,
            rechercheCollapsable: false
        }
    };
}
